import { LocaleService } from "@jutro/locale";
import { warning } from "@jutro/logger";
import { analyticsHandler } from "./handlers/analyticsHandler";
import { jsonOptions } from "./options/jsonOptions";
import { langLocaleOptions } from "./options/langLocaleOptions";
import { HttpRequestBuilder } from "./HttpRequestBuilder";
export function createHttpRequest(baseUrl) {
  var build = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
    request = new HttpRequestBuilder(baseUrl).addHandler(analyticsHandler);
  return LocaleService.JUTRO_PRIVATE_NOT_USE_LOCALE_SERVICE || (warning("@jutro/transport createHttpRequest: headers will not be automatically propagated with gw-language and gw-locale starting from Jutro 10. You need add langLocaleOptions manually. See documentation for more details."), request.addOptions(langLocaleOptions(LocaleService.getCurrentLanguage(), LocaleService.getCurrentLocale()))), build ? request.build() : request;
}
export function createJsonHttpRequest(baseUrl) {
  var build = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
    request = createHttpRequest(baseUrl, !1).addOptions(jsonOptions);
  return build ? request.build() : request;
}